export default __webpack_public_path__ + "static/school-dc8dbb4dbd2e91910144b57edd9f1d9a.png";